import { render, staticRenderFns } from "./EditPromo.vue?vue&type=template&id=49b9aaca"
import script from "./EditPromo.vue?vue&type=script&lang=js"
export * from "./EditPromo.vue?vue&type=script&lang=js"
import style0 from "./EditPromo.vue?vue&type=style&index=0&id=49b9aaca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports